import React from 'react'
import { useIntl, FormatNumberOptions } from 'react-intl'
import { IMachine } from 'msp-integrations'

import translations from './AccountMachineDisplayStats.constants'
import * as S from './AccountMachineDisplayStats.styles'

export type AccountMachineDisplayStatsProps = {
  machine: IMachine
}

const AccountMachineDisplayStats = ({
  machine
}: AccountMachineDisplayStatsProps) => {
  const { formatMessage, formatNumber } = useIntl()
  const hasNoStats = machine.appDownloadDate === null
  const volumeFormatOptions: FormatNumberOptions = {
    maximumFractionDigits: 2,
    style: 'unit',
    unit: 'liter',
    unitDisplay: 'short'
  }

  return (
    <div className={S.Wrapper}>
      {hasNoStats && (
        <div className={S.NoStats}>{formatMessage(translations.noStats)}</div>
      )}
      {!hasNoStats && (
        <>
          <div className={S.StatItemWrapper}>
            <div className={S.StatLabel}>
              {formatMessage(translations.nextDescaling)}
            </div>
            <div className={S.StatContent}>
              {machine.cupsUntilCleaning > 0 &&
                formatMessage(translations.nextDescalingAfterCups, {
                  cups: machine.cupsUntilCleaning || 0
                })}
              {machine.cupsUntilCleaning === 0 && 'N/A'}
            </div>
          </div>
          <div className={S.StatItemSeparator}></div>
          <div className={S.StatItemWrapper}>
            <div className={S.StatLabel}>
              {formatMessage(translations.waterConsumption)}
            </div>
            <div className={S.StatContent}>
              {formatMessage(translations.waterConsumptionVolume, {
                volume: formatNumber(
                  (machine.waterConsumption || 0) / 1000,
                  volumeFormatOptions
                )
              })}
            </div>
          </div>
          <div className={S.StatItemSeparator}></div>
          <div className={S.StatItemWrapper}>
            <div className={S.StatLabel}>
              {formatMessage(translations.brewedCups)}
            </div>
            <div className={S.StatContent}>
              {formatMessage(translations.brewedCupsNo, {
                cups: machine.totalCups || 0
              })}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default AccountMachineDisplayStats
